import { toast } from "react-toastify";
import { API_ENVIOS } from "../views/MainLayout/components/shared/services/envios";
import { setErrorMessage } from "../views/MainLayout/components/shared/helpers/functionalities";

const initialEnvios = []

export const enviosReducer = (state = initialEnvios, action) => {
    switch(action.type){
        case "envios/fullfilled": {            
            return action.payload;
        }
        default:
            return state
    }
}

export const fetchEnvios = (page, search) => async dispatch => {
    dispatch({ type: 'loading/set', payload: true })

    try {
        const response = await API_ENVIOS.getEnvios(page, search)
        const data = await response.data;
        dispatch({ type: 'envios/fullfilled', payload: data })
    } catch (e) {
        toast.error(setErrorMessage(e))
    } finally {
        dispatch({ type: 'loading/set', payload: false })
    }
}